import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import BottomSheet from '@/modals/BottomSheet/BottomSheet';
import { Image } from 'react-native';
export default function FormExitConfirmBottomSheet({ isVisible, onConfirm, onCancel, }) {
    return (_jsx(BottomSheet, { isVisible: isVisible, onPressBackground: onCancel, children: _jsxs(ContentsContainer, { children: [_jsx(IconContainer, { children: _jsx(Image, { source: require('@/assets/img/img_memo.png'), style: {
                            width: 75,
                            height: 60,
                        } }) }), _jsx(Title, { children: "\uC557, \uC785\uB825\uC744 \uC911\uB2E8\uD558\uC2DC\uACA0\uC5B4\uC694?" }), _jsx(Description, { children: '작성 중인 내용은\n저장되지 않고 바로 삭제됩니다.' }), _jsxs(ButtonContainer, { children: [_jsx(SccButton, { text: "\uB098\uC911\uC5D0 \uD558\uAE30", elementName: "form_exit_confirm_button", onPress: onConfirm, buttonColor: "gray20", textColor: "gray70", fontFamily: font.pretendardMedium, height: 48, style: { flex: 1, borderRadius: 14 } }), _jsx(SccButton, { text: "\uC774\uC5B4\uC11C \uC791\uC131\uD558\uAE30", elementName: "form_exit_cancel_button", onPress: onCancel, buttonColor: "brand40", textColor: "white", fontFamily: font.pretendardSemibold, height: 48, style: { flex: 1, borderRadius: 14 } })] })] }) }));
}
const ContentsContainer = styled.View({
    paddingTop: 20,
    paddingHorizontal: 20,
});
const IconContainer = styled.View({
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 12,
});
const Title = styled.Text({
    fontSize: 20,
    fontFamily: font.pretendardBold,
    color: color.black,
    textAlign: 'center',
    lineHeight: 28,
    letterSpacing: -0.4,
});
const Description = styled.Text({
    fontSize: 16,
    fontFamily: font.pretendardRegular,
    color: color.gray70,
    lineHeight: 24,
    textAlign: 'center',
    marginTop: 5,
    marginBottom: 12,
});
const ButtonContainer = styled.View({
    flexDirection: 'row',
    gap: 10,
    paddingVertical: 12,
});
